import * as ss from 'superstruct';
import { MicrosoftAdsCustomerId } from '../../tracking/ad-account-id';

export const MicrosoftAdsConversionOutputStreamDestination = ss.type({
  name: ss.literal('microsoft-ads-conversion'),
  /**
   * The conversion name to apply the conversion to.
   */
  conversionName: ss.string(),
  /**
   * The Microsoft Ads account ID (named customerId for historical reasons),
   * sent as the CustomerAccountId header. Must be linked to the management
   * customer.
   */
  customerId: MicrosoftAdsCustomerId,
  /**
   * If we should send any identifying info in the conversion to Microsoft
   * (email, phone).
   */
  enhanced: ss.boolean(),
});

export type MicrosoftAdsConversionOutputStreamDestination = ss.Infer<
  typeof MicrosoftAdsConversionOutputStreamDestination
>;
